import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "wildcat-theme"

// Connects to data-controller="theme"
export default class extends Controller {
  static targets = ["lightButton", "darkButton"]

  connect() {
    this.syncButtons(this.currentTheme)
  }

  setLight() {
    this.applyTheme("light")
  }

  setDark() {
    this.applyTheme("dark")
  }

  applyTheme(theme) {
    document.documentElement.classList.toggle("dark", theme === "dark")
    localStorage.setItem(STORAGE_KEY, theme)
    this.syncButtons(theme)
  }

  syncButtons(theme) {
    if (this.hasLightButtonTarget) this.setActive(this.lightButtonTarget, theme === "light")
    if (this.hasDarkButtonTarget) this.setActive(this.darkButtonTarget, theme === "dark")
  }

  setActive(button, active) {
    button.classList.toggle("bg-white", active)
    button.classList.toggle("dark:bg-stone-900", active)
    button.classList.toggle("text-primary-600", active)
    button.classList.toggle("dark:text-primary-400", active)
    button.classList.toggle("shadow-sm", active)
    button.classList.toggle("text-stone-500", !active)
    button.classList.toggle("dark:text-stone-400", !active)
    button.setAttribute("aria-pressed", active)
  }

  get currentTheme() {
    return document.documentElement.classList.contains("dark") ? "dark" : "light"
  }
}
